import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import showStatement from './showStatement';

var CreateProtocolDialog = function (_super) {
  __extends(CreateProtocolDialog, _super);

  function CreateProtocolDialog() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.formDataRule = {
      doc_type: [{
        required: true,
        message: _this.tc('请选择协议')
      }]
    };
    _this.formData = _this.initFormData();
    _this.visible = false;
    _this.protocolTypeList = [];
    return _this;
  }

  CreateProtocolDialog.prototype.initFormData = function () {
    return {
      doc_type: '',
      doc_version: ''
    };
  };

  CreateProtocolDialog.prototype.handleVisibleChange = function (val) {
    var formDataRef = this.$refs.formDataRef;
    formDataRef && formDataRef.resetFields();
    val && this.queryProtocolList();
  };

  CreateProtocolDialog.prototype.queryProtocolList = function () {
    return __awaiter(this, void 0, void 0, function () {
      var data, list, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4, this.$api.user.queryUserAgreementList({})];

          case 1:
            data = _a.sent().data;
            list = data.list || [];
            this.protocolTypeList = list.filter(function (i) {
              return i.is_signed !== 1;
            });
            return [3, 3];

          case 2:
            error_1 = _a.sent();
            this.protocolTypeList = [];
            return [3, 3];

          case 3:
            return [2];
        }
      });
    });
  };

  CreateProtocolDialog.prototype.handleClose = function () {
    this.visible = false;
  };

  CreateProtocolDialog.prototype.handleOk = function () {
    return __awaiter(this, void 0, void 0, function () {
      var formDataRef;

      var _this = this;

      return __generator(this, function (_a) {
        formDataRef = this.$refs.formDataRef;
        formDataRef.validate(function (valid) {
          return __awaiter(_this, void 0, void 0, function () {
            var info, res;

            var _this = this;

            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  if (!valid) {
                    return [2];
                  }

                  info = this.protocolTypeList.find(function (i) {
                    return i.doc_type === _this.formData.doc_type;
                  });

                  if (!info) {
                    return [2, this.$message.error(this.t('协议不存在'))];
                  }

                  return [4, showStatement(this.formData.doc_type, info.doc_type_text, function () {
                    _this.$emit('success');
                  })];

                case 1:
                  res = _a.sent();
                  this.handleClose();

                  if (!res) {
                    return [2, this.$message.error(this.t('未找到协议信息或协议已签署，请刷新重试'))];
                  }

                  return [2];
              }
            });
          });
        });
        return [2];
      });
    });
  };

  __decorate([Watch('visible', {
    immediate: true,
    deep: false
  })], CreateProtocolDialog.prototype, "handleVisibleChange", null);

  CreateProtocolDialog = __decorate([Component({})], CreateProtocolDialog);
  return CreateProtocolDialog;
}(Vue);

export default CreateProtocolDialog;